/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgNone = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M3 12a9 9 0 1 0 18 0 9 9 0 0 0-18 0m4.084 5.664a7.5 7.5 0 0 0 10.58-10.58zm-1.03-1.092A7.5 7.5 0 0 1 16.573 6.054z" clipRule="evenodd" /></svg>;
export default SvgNone;